var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 21"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Linkedin_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.184 0H1.944A1.493 1.493 0 0 0 .451 1.493v17.24a1.493 1.493 0 0 0 1.493 1.493h17.24a1.493 1.493 0 0 0 1.493-1.493V1.493A1.493 1.493 0 0 0 19.184 0M6.48 17.23H3.439V7.57h3.04zM4.957 6.232a1.746 1.746 0 1 1 1.756-1.744 1.72 1.72 0 0 1-1.756 1.744m12.731 11.006h-3.04v-5.277c0-1.556-.661-2.036-1.515-2.036-.902 0-1.786.68-1.786 2.076v5.237H8.306v-9.66h2.924v1.338h.04c.293-.594 1.32-1.61 2.89-1.61 1.697 0 3.53 1.008 3.53 3.957z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Linkedin_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.451 0h20.226v20.226H.451z"
  })))));
};
export { SvgLinkedin as ReactComponent };